<template>
    <GmapMap :center="centerMap" :zoom="7" map-type-id="terrain" style="width: 100%; height: calc(100vh - 300px)" ref="searchmap">
        <GmapMarker :key="index" v-for="(m, index) in markers" :position="m.position" :clickable="true" :draggable="false" @click="showInfoWindow(m)" />
    </GmapMap>

</template>

<script>
    import gmapcluster from 'vue2-google-maps/src/components/cluster';
    import { loadGmapApi } from 'vue2-google-maps';
    const mapstyle_light = require("./Styles/json/mapstyle_light.json");

    export default {
        props: ['currentsearch', 'host'],
        components: {
            gmapcluster
        },
        methods: {

            /**
             * Mostro la infowindow sul marker passato
             */
            showInfoWindow(marker) {

                if (this.currentInfoWindow) {
                    this.currentInfoWindow.close();
                }

                let template = '<a style="text-decoration: none;" href="/immobile/' + marker.customInfo.slug + '" target="_blank"><div style="width: 310px; margin-left: 5px; margin-top: 7px; margin-bottom: -10px">' +
                    '<img src="' + marker.customInfo.thumbnail.sizes['512'] + '" width="100%"/>' +
                    '<p style="margin-top:7px">' + marker.customInfo.tipologia + '</p>' +
                    '<p style="font-size: 1.3em"><b>Prezzo ' + marker.customInfo.price + '</b></p>' +
                    '</div>' +
                    '</a>';

                this.currentInfoWindow = new google.maps.InfoWindow({
                    content: template
                });

                // Non so quanto è grande il marker trovata soluzione qui: https://stackoverflow.com/a/24715250

                this.currentInfoWindow.setOptions({
                    position: marker.getPosition(),
                    pixelOffset: new google.maps.Size(0, -40),
                    map: this.map
                });

                // Apro la InfoWindow
                this.currentInfoWindow.open(this.map, marker);
                this.map.panTo(marker.customInfo.location);

            },

            /**
             * Disegno i Pins
             */
            drawPins(search) {
                // Mostro il loading dall'istanza principale
                this.$root.isLoading('loading-toast');

                search.is_map = true;

                // Effettuo la chiamata al server
                window.axios.post(process.env.MIX_BASE_URL + 'immobili/search', search).then(res => {

                    // Creo un'array di marker da passare al componente gmapmarker
                    this.addMarker(res.data.data);

                    // Nascondo eventuali spinner
                    this.$root.stopLoading();
                }).catch(error => {
                    // Stoppo il loading
                    this.$root.stopLoading();

                    // Mostro alert
                    this.$root.alertHttp('loading-toast', 'Problemi nel caricamento dati');
                })
            },

            /**
             * Aggiungo il marker
             * @param {*} res
             * @param {*} mapObject
             */
            addMarker(res, mapObject) {
                var marker, i;

                for (i = 0; i < res.length; i++) {

                    marker = new google.maps.Marker({
                        position: new google.maps.LatLng(res[i].location.lat, res[i].location.lng),
                        map: mapObject,
                        customInfo: res[i]
                    });

                    this.markers.push(marker);
                }

                var bounds = new google.maps.LatLngBounds();

                for (var i = 0; i < this.markers.length; i++) {
                    bounds.extend(this.markers[i].getPosition());
                }

                this.map.fitBounds(bounds);
            },

        },

        mounted() {
            // Centro al punto impostato sull'host
            if (this.host.capoluogo_center) {
                this.centerMap = {
                    lat: this.host.capoluogo_center.coordinates[1],
                    lng: this.host.capoluogo_center.coordinates[0],
                };
            }
            // Piazzo i pin
            this.$refs.searchmap.$mapPromise.then((map) => {
                this.map = map;
                this.drawPins(this.currentsearch);
            });

        },
        beforeMount() {
            // Controllo di non aver già caricato la mappa
            if(! this.$root.mapLoaded){
                // Carico lo script di gmaps
                loadGmapApi({
                    key: this.$root.host ? this.$root.host.google_maps_key : null,
                    libraries: 'places,drawing',
                });
                // Imposto la mappa come caricata
                this.$root.mapLoaded = true;
            }
        },
        data() {
            return {
                centerMap: {
                    lat: 44.699125,
                    lng: 10.639077
                },
                zone: null,
                infowindow: null,
                map: null,
                markers: [],
                currentInfoWindow: null,
            };
        }
    };
</script>

<style lang="scss">
    @import './Styles/main.css';
</style>